import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { PageViews, Website } from "@/api/types"

export function topPagesOptions(website: Website, days: number) {
	return queryOptions({
		queryKey: ["analytics", website, "top-pages", days],
		queryFn: (): Promise<PageViews[]> =>
			GET("/api/v1/analytics/{website}/top-pages", {
				params: { path: { website }, query: { days } },
			}),
	})
}

export function useTopPages(website: Website, days: number) {
	return useQuery(topPagesOptions(website, days))
}
